import { call, put, takeLatest } from "redux-saga/effects";

import { getAPIPayload } from "../../../../apis/getApi";
import { postAPIPayload } from "../../../../apis/postApi";
import { adminRiskAssessmentsAction } from "../../../slices/admin/adminRiskAssessments/adminRiskAssessmentsSlice";

function buildQuery(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  });
  const query = params.toString();
  return query ? `?${query}` : "";
}

export function* fetchAssessmentsListSaga({ payload }) {
  const apiBasePath = payload?.apiBasePath || "admin/risk-assessments";
  const filters = payload?.filters || {};
  const response = yield call(getAPIPayload, {
    url: `${apiBasePath}${buildQuery(filters)}`,
    token: true,
  });
  yield put(adminRiskAssessmentsAction.assessmentsListLoaded(response));
}

export function* fetchAssessmentStatsSaga({ payload }) {
  const apiBasePath = payload?.apiBasePath || "admin/risk-assessments";
  const filters = payload?.filters || {};
  const response = yield call(getAPIPayload, {
    url: `${apiBasePath}/stats${buildQuery(filters)}`,
    token: true,
  });
  yield put(adminRiskAssessmentsAction.assessmentStatsLoaded(response));
}

export function* runAssessmentSaga({ payload }) {
  const response = yield call(postAPIPayload, { ...payload, token: true });
  yield put(adminRiskAssessmentsAction.assessmentRunComplete(response));
}

export function* shareAssessmentSaga({ payload }) {
  const response = yield call(postAPIPayload, { ...payload, token: true });
  yield put(adminRiskAssessmentsAction.assessmentShared(response));
}

export function* enableAssessmentMonitoringSaga({ payload }) {
  const response = yield call(postAPIPayload, { ...payload, token: true });
  yield put(adminRiskAssessmentsAction.assessmentMonitoringEnabled(response));
}

export function* watchAdminRiskAssessmentsSaga() {
  yield takeLatest(
    adminRiskAssessmentsAction.fetchAssessmentsList,
    fetchAssessmentsListSaga
  );
  yield takeLatest(
    adminRiskAssessmentsAction.fetchAssessmentStats,
    fetchAssessmentStatsSaga
  );
  yield takeLatest(adminRiskAssessmentsAction.runAssessment, runAssessmentSaga);
  yield takeLatest(adminRiskAssessmentsAction.shareAssessment, shareAssessmentSaga);
  yield takeLatest(
    adminRiskAssessmentsAction.enableAssessmentMonitoring,
    enableAssessmentMonitoringSaga
  );
}
